import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import "react-datepicker/dist/react-datepicker.css";
import { MdRemoveRedEye, MdEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader, BounceLoader } from "react-spinners";
import { useReactToPrint } from "react-to-print";
import * as yup from "yup";
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import CustomerType from "../../../../components/modals/customers/create/CustomerType";
import PaginationLinks from "../../../../components/pagination/PaginationLinks";
import PageTitle from "../../../../components/partials/PageTitle";
import { resetAttachPolicyCustomer } from "../../../../redux/slice/customer/customerSlice";
import {
  FilteredAppliedPolicies,
  getAppliedPolicies,
  getSinglePolicyCover,
  resetAttachedPolicyPreview,
  resetCustomerSinglePolicyDetailsView,
  resetPolicyStatus,
  resetSinglePolicy,
  searchAppliedPolicies,
} from "../../../../redux/slice/policy/policySlice";
import {
  exportXlsxData,
  sortUsersByOffice,
} from "../../../../utils/helpers/functions";
import Select from ".././../../../components/form/select/Select";
import {
  FilteredGeneralPolicyClaims,
} from "../../../../redux/slice/claim/claimSlice";
import { getSavingsClaims, resetClaimStatus, resetSingleClaims } from "../../../../redux/slice/claim/savingClaimSlice";

// sort customers base on whether corperate or individual customers
// const sortCorperateCustomers = (customers) =>
//   customers?.corperate?.data?.filter(
//     (customer) => customer?.customer_type === "Corporate"
//   );

// main component starts here
const AllSavingsClaims = () => {
  // redux state calls
  const { user, user_permissions } = useSelector((state) => state?.auth?.user);
  const { unpaginated_users } = useSelector((state) => state?.user);
  const { claims, isSuccess, isFiltered, isFiltering, isSearching } =
    useSelector((state) => state?.savingsClaim);
  const {
    offices: { offices },
  } = useSelector((state) => state.office);

  // local states and refs
  const [hasViewClaim, setHasViewClaim] = useState(null);
  const [currentClaims, setCurrentClaims] = useState();
  const [viewCustomer, setViewCustomer] = useState();
  const [editPolicy, setEditPolicy] = useState();
  // const [attachPolicy, setAttachPolicy] = useState()
  const [sortedUsers, setSortedUsers] = useState([]);
  const [filtered, setFiltered] = useState("");
  const [filteredItem, setFilteredItem] = useState(false);
  const [searchBy, setSearchBy] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [hasInitiateClaim, setHasInitiateClaim] = useState(null);
  const agentRef = useRef();
  const allCorperateCustomers = useRef();
  const appliedPoliciesRef = useRef();
  const searchCorp = useRef();
  const CCPdfRef = useRef();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "initiated claims",
  });
  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Savings Policy Claims",
      link: "/admin/claims/all-savings-claims",
    },
    current: {
      title: "overview",
      link: null,
    },
  };

  const handleSearchBy = (e) => {
    e.preventDefault();
    if (searchBy) {
      dispatch(
        getSavingsClaims({
          pageNumber,
          office_id: user?.office_id,
          search: searchBy,
        })
      );
    }
  };
  //
  // fetch customers on click of pagination links
  const fetchCorperateCustomersHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(
      getSavingsClaims({
        pageNumber: pageNum,
        office_id: user?.office_id,
        search: searchBy === undefined ? "" : searchBy,
      })
    );
    // dispatch(resetPolicyStatus());
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    setFieldError,
    resetForm,
  } = useFormik({
    // enableReinitialize: true,
    initialValues: {
      office_id: "",
      staff_id: "",
    },
    validationSchema: () =>
      yup.object().shape({
        office_id: yup.number().required("Office is required"),
      }),
    onSubmit: (values) => {
      if (values?.staff_id === undefined) {
        values["staff_id"] = "";
      }
      dispatch(resetPolicyStatus());
      dispatch(FilteredGeneralPolicyClaims(values));
      // setFiltered("");
    },
  });

  const clearFilteredItems = () => {
    appliedPoliciesRef?.current?.clearValue();
    // agentRef?.current?.clearValue();
    setSearchBy("");
    dispatch(
      getSavingsClaims({
        pageNumber: pageNumber,
        office_id: user?.office_id,
        search: "",
      })
    );
    resetForm();
    setFilteredItem(false);
  };

  // get all claims on first load
  useEffect(() => {
    dispatch(
      getSavingsClaims({
        pageNumber: 1,
        office_id: user?.office_id,
        search: searchBy === undefined ? "" : searchBy,
      })
    );
    dispatch(resetClaimStatus());
    dispatch(resetSingleClaims());
  }, [dispatch, user?.office_id]);

  useEffect(() => {
    if (claims) {
      setCurrentClaims(claims?.claim_process_details?.data);
      // dispatch(resetCustomerSinglePolicyDetailsView());
    }
  }, [claims]);

  useEffect(() => {
    agentRef?.current?.clearValue();
    if (values?.office_id) {
      let sortedUsers = sortUsersByOffice(values?.office_id, unpaginated_users);
      setSortedUsers(sortedUsers);
    } else {
      setSortedUsers([]);
    }
  }, [values?.office_id, unpaginated_users]);

  // filtering by search input
  useEffect(() => {
    if (isSuccess) {
      setFiltered("");
      dispatch(resetPolicyStatus());
    }

    if (isFiltered) {
      setFilteredItem(true);
      dispatch(resetClaimStatus());
    }

    if (searchBy) {
      setFilteredItem(true);
    }

    if (filtered !== "") {
      setCurrentClaims(
        claims?.claim_process_details?.data?.filter(
          (item) => item.status === filtered
        )
      );
    } else {
      setCurrentClaims(claims?.claim_process_details?.data);
    }
  }, [filtered, isSuccess, isFiltered]);

  // useEffect(() => {
  //   dispatch(resetAttachPolicyCustomer());
  //   dispatch(resetSinglePolicy());
  //   dispatch(resetAttachedPolicyPreview());
  // }, [dispatch]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "claim module"
      )
    ) {
      navigate("/admin/dashboard");
    }

    setHasViewClaim(
      user_permissions?.some((permission) => permission.name === "view claim")
    );

    setHasInitiateClaim(
      user_permissions?.some((permission) => permission.name === "initiate claim")
    );
  }, [navigate, user_permissions]);

  if (!claims) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Savings Policy Claims' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row mt- card p-1 mx-0'>
        <div className='row mb-3'>
          <form className='col-md-9' onSubmit={handleSubmit}>
            <div className='row mt-4'>
              <div className='col-sm-2 text-end sm-text-end'>
                <label htmlFor='account_type' className={`form-label mt-1`}>
                  Office <span className='text-danger'>*</span>
                </label>
              </div>

              <div className='col-sm-6'>
                <Select
                  onBlur={() => {
                    handleBlur({ target: { name: "office_id" } });
                  }}
                  name='office_id'
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  // value={parseInt(values?.office_id)}
                  onChange={(selectedOption) => {
                    setFieldValue("office_id", selectedOption?.value);
                  }}
                  ref={appliedPoliciesRef}
                />
                {errors?.office_id && touched?.office_id && (
                  <p className='mb-0 text-danger'>{errors?.office_id + "*"}</p>
                )}
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-sm-2 text-end sm-text-end'>
                <label htmlFor='account_type' className={`form-label mt-1`}>
                  Agent
                </label>
              </div>
              <div className='col-sm-6'>
                <Select
                  onBlur={() => {
                    handleBlur({ target: { name: "staff_id" } });
                  }}
                  name='staff_id'
                  ref={agentRef}
                  data={
                    values.office_id === 1
                      ? unpaginated_users?.map((item) => ({
                          label: item?.last_name + " " + item?.first_name,
                          value: item?.staff_id,
                        }))
                      : sortedUsers
                  }
                  onChange={(selectedOption) => {
                    setFieldValue("staff_id", selectedOption?.value);
                    setFieldError("staff_id", "");
                  }}
                />
                <div className='d-flex align-items-center gap-2 mt-2'>
                  <button type='submit' className='btn btn-sm btn-primary '>
                    Filter
                  </button>
                  {filteredItem ? (
                    <button
                      type='button'
                      className='btn btn-sm btn-secondary'
                      onClick={clearFilteredItems}
                    >
                      Clear Filter
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
          {hasInitiateClaim && <div className='col-md-2'>
            <button
              className='btn btn-sm btn-primary mt-4'
              onClick={() => navigate("/admin/savings-claims")}
            >
              Initiate claim
            </button>
          </div>}
        </div>

        <div className='d-flex justify-content-between align-items-center py-2 mt-2'>
          <div>
            <h4 className='text-primary-1'>Savings Policy Claims</h4>
          </div>
          <div className='d-flex justify-content-between align-items-center gap-3'>
            <form
              onSubmit={handleSearchBy}
              className='d-flex bg-primary-1 align-items-center '
              style={{ height: "30px", width: "217px" }}
              ref={searchCorp}
            >
              <input
                type='search'
                value={searchBy}
                className='border-0'
                placeholder='Search...'
                onChange={(e) => setSearchBy(e.target.value)}
                style={{
                  height: "28px",
                  marginLeft: "1px",
                  outline: "none",
                }}
              />
              <button
                type='submit'
                className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                style={{ height: "28px" }}
              >
                <i className='uil uil-search text-white fs-4'></i>
              </button>
            </form>
            <div className=' d-flex align-items-center border '>
              <span
                className='bg-info me-2 text-white'
                style={{ padding: "3px" }}
              >
                Export to
              </span>

              <span
                href='#'
                id='btnExport'
                className='me-1 cursor-p'
                title='Export to Pdf'
                onClick={generatePDF}
              >
                <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
              </span>
              {currentClaims ? (
                <CSVLink
                  data={exportXlsxData(currentClaims, "All Policies")}
                  style={{ fontWeight: "bolder", cursor: "pointer" }}
                  filename='Corperate customers'
                >
                  <span
                    href='#'
                    id='btnExport'
                    className='mr-1'
                    title='Export to Excel'
                  >
                    <img
                      src={excel}
                      alt='export-excel'
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink>
              ) : null}
            </div>
          </div>
        </div>
        <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table
                    className='table table-centered table-striped nowrap w-100 no-footer'
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "130.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Claims ID
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "130.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Claims Type
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "225.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Customer ID
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Customer Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Customer Type
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy No.
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                          aria-label='Email: activate to sort column ascending'
                        >
                          Agent
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "206.8px" }}
                          aria-label='Location: activate to sort column ascending'
                        >
                          Office
                        </th>

                        <th
                          className='sorting sorting_asc'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                        >
                          Status
                        </th>
                        {hasViewClaim && (
                          <th
                            className='sorting text-center'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "165.8px" }}
                            aria-label='Status: activate to sort column ascending'
                          >
                            Action
                          </th>
                        )}
                      </tr>
                    </thead>
                    {currentClaims?.length ? (
                      <tbody>
                        {currentClaims?.map((item, i) => (
                          <tr key={i}>
                            <td>
                              <span>{item.claim_id}</span>
                            </td>
                            <td className="table-user">
                            <span className="">
                              {item?.claim_type
                                ? item?.claim_type === "1" && "Maturity"
                                : null}
                            </span>
                            <span className="">
                              {item?.claim_type
                                ? item?.claim_type === "2" && "Termination"
                                : null}
                            </span>
                            <span className="">
                              {item?.claim_type
                                ? item?.claim_type === "3" && "Partial Withdrawal"
                                : null}
                            </span>
                            <span className="">
                              {item?.claim_type
                                ? item?.claim_type === "4" && "Death Benefit"
                                : null}
                            </span>
                          </td>
                            <td>{item?.customerId}</td>
                            <td className=''>
                              {" "}
                              {item?.customerFirstName +
                                " " +
                                item?.customerLastName}
                            </td>
                            <td>{item?.customer_type}</td>
                            <td>{item?.policyAppNumber}</td>

                            <td>{item?.policyName}</td>
                            <td className=''>
                              {" "}
                              {item?.agentFirstName + " " + item?.agentLastName}
                            </td>
                            <td className=''>{item?.office_name}</td>
                            <td>
                              <span className='badge badge-warning-lighten'>
                                {item?.awaiting_status &&
                                item?.decline_status === "0" &&
                                item?.claim_status === "0"
                                  ? "Awaiting " +
                                    item?.awaiting_status +
                                    " approval"
                                  : null}
                              </span>
                              <span className='badge badge-danger-lighten'>
                                {item?.decline_status &&
                                item?.claim_status === "0" &&
                                item?.decline_status !== "0"
                                  ? item?.decline_status
                                  : null}
                              </span>
                              <span className='badge badge-success-lighten'>
                                {item?.claim_status
                                  ? item?.claim_status === "1" && "Approved"
                                  : null}
                              </span>
                            </td>
                            {claims && hasViewClaim && (
                              <td className='text-center'>
                                <Link
                                  to={`/admin/claims/all-savings-claims/edit`}
                                  className='text-left'
                                  state={{ claim_type:item?.claim_type, claim_category: item?.claim_category, claim_id: item?.claim_id, policy_application_number: item?.policyAppNumber, customer_id: item?.customerId}}
                                  // onClick={() =>
                                  //   dispatch(getSingleClaim(item?.claim_id))
                                  // }
                                >
                                  <MdRemoveRedEye
                                    className='text-primary'
                                    style={{
                                      fontSize: "20px",
                                      textAlign: "start",
                                    }}
                                  />
                                </Link>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {currentClaims?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
                <div className='row mt-2'>
                  <div className='col-sm-12 col-md-6'>
                    <div
                      className='dataTables_info table-pages'
                      id='products-datatable_info'
                      role='status'
                      aria-live='polite'
                    >
                      Showing offices {claims?.claim_process_details?.from} to{" "}
                      {claims?.claim_process_details?.to} of{" "}
                      {claims?.claim_process_details?.total}
                    </div>
                  </div>
                  <div className='col-sm-12 col-md-6'>
                    <PaginationLinks
                      paginationData={claims?.claim_process_details}
                      getNextPage={fetchCorperateCustomersHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
            {isFiltering && searchBy !== undefined && (
              <div
                className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                style={{ height: "100%" }}
              >
                <div className='mx-auto'>
                  <BounceLoader
                    color='#090b8f'
                    loading={true}
                    // cssOverride={override}
                    size={50}
                    aria-label='Loading Spinner'
                    data-testid='loader'
                    className='ms-3'
                  />
                  <span className='fw-bolder text-primary-1 ms-2'>
                    Please wait...
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        <CustomerType modal_id='create_customer_step_1' />
      </div>
    </>
  );
};

export default AllSavingsClaims;
